export class Supplier {
    id:number = 0;
    business_name:string = '';
    rfc:string = '';
    street:string = '';
    colony:string = '';
    zip_code:string = '';
    locality:string = '';
    state:string = '';
    phone_number:string = '';
    email:string = '';
    active:boolean = false;
    contact_name: string | null;
    credit_days:number = 0;
}

